// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Table[data-v-380eb46a]{background-color:var(--timelapse-color)}.Table__row[data-v-380eb46a]:hover{background-color:var(--timelapse-color-darkened)}.PressUpdatesTable__body[data-v-380eb46a]{opacity:var(--table-body-opacity)}\n", ""]);
// Exports
module.exports = exports;
